import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck'
import { notifications } from '@mantine/notifications'

import { useTranslation } from '@flecto/translations'
import { Icon } from '@flecto/ui'

export function useAddressNotification() {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_locations' })

  const showNotification = () => {
    notifications.show({
      color: 'green',
      icon: <Icon icon={faCheck} />,
      title: t('notifications.title'),
      message: t('notifications.address_saved'),
    })
  }

  return { showNotification }
}
